"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.submitClick = exports.buttonClick = exports.removeForm = exports.loadNewForm = void 0;
const immer_1 = require("immer");
const functional_1 = require("../utils/functional");
const submission_1 = require("../handlers/submission");
const set_data_1 = require("../utils/set-data");
const move_field_details_to_model_1 = __importDefault(require("../utils/move-field-details-to-model"));
const handle_action_1 = __importDefault(require("../handlers/handle-action"));
const binds_1 = __importDefault(require("../handlers/binds"));
// =======
// ACTIONS
// =======
const constants_1 = require("../constants");
// ===============
// ACTION CREATORS
// ===============
const getDispatcher = (dispatchers, name) => dispatchers[name] || dispatchers.fallback;
const loadNewForm = ({ forms, id, initialData, elementInjections, childForm, }) => {
    const partition = forms.reduce((acc, { model, ...form }) => {
        acc.models.push(model);
        acc.forms.push(form);
        return acc;
    }, { models: [], forms: [] });
    const { models, forms: nextForms } = (0, immer_1.produce)(partition, (draft) => {
        (0, move_field_details_to_model_1.default)(draft);
        (0, set_data_1.setModelDataInitial)({
            models: draft.models,
            data: initialData,
            elementInjections,
        });
        draft.forms.forEach(({ onReady = [], binds = [] }) => {
            (0, handle_action_1.default)({ actions: onReady, binds })(draft.models);
            (0, binds_1.default)({ binds })(draft.models);
        });
        (0, set_data_1.setModelDataOnReady)({ models: draft.models });
    });
    return {
        type: constants_1.LOAD_NEW_FORMS,
        version: 1,
        id,
        forms: nextForms,
        models,
        index: childForm
            ? forms.findIndex(({ name }) => name === childForm)
            : forms.findIndex(({ groups }) => groups),
    };
};
exports.loadNewForm = loadNewForm;
const removeForm = (id) => ({
    type: constants_1.REMOVE_FORM,
    id,
});
exports.removeForm = removeForm;
const buttonClick = ({ payload: { name, ...payload }, dispatchers }, passData) => getDispatcher(dispatchers, name)({ actionName: name, payload }, passData);
exports.buttonClick = buttonClick;
const submitClick = ({ submission, submitPayload: { method, mediatype, separator, target, modelRef, submissionType, submissionData, onSubmit, ...payload }, dispatchers, formId, repeatIndex, }, passData) => (dispatch, getState) => {
    dispatch({
        type: constants_1.RUN_PRE_SUBMIT_ACTIONS,
        updates: onSubmit,
        formId,
        repeatIndex,
    });
    const { config, models, formModel, version } = getState().rex;
    const useComposure = version[formId] > 1;
    const body = useComposure
        ? (0, submission_1.buildFormModelSubmissionBody)(submissionType, formModel, formId, submissionData, separator)
        : (0, submission_1.buildSubmissionBody)(models[formId], {
            modelRef,
            method,
            mediatype,
            separator,
        });
    const submitData = {
        ...payload,
        target,
        method,
        mediatype,
        separator,
        body,
        config,
    };
    const action = target && target !== '_self'
        ? (0, submission_1.newWindowSubmission)(submitData)
        : (0, submission_1.fetchSubmission)(submitData);
    const dispatchFn = getDispatcher(dispatchers, submission);
    if (!dispatchFn) {
        const error = new Error(`App is missing dispatcher for handling Rex submissions of type: ${submission}`);
        throw error;
    }
    return dispatch(dispatchFn({
        action,
        actionName: submission,
        body: submitData.body,
        getRequestData: () => useComposure
            ? (0, submission_1.getFormModelData)(formModel, formId, submissionData)
            : (0, submission_1.getSubmissionRequestData)(models[formId], modelRef),
        formId,
        repeatIndex,
    }, passData));
};
exports.submitClick = submitClick;
// =======
// REDUCER
// =======
const formReducer = (state = {}, action) => {
    switch (action.type) {
        case constants_1.LOAD_NEW_FORMS: {
            return {
                ...state,
                [action.id]: action.forms,
            };
        }
        case 'FormModel/LOAD_FORM': {
            return {
                ...state,
                // dummy form
                [action.payload.modelKey]: action.payload.layout.stages,
            };
        }
        case constants_1.REMOVE_FORM: {
            return functional_1.pipe.objToArr(state)(
            // filter out the item where they key matches id
            (0, functional_1.filter)(([k]) => k !== action.id), 
            // merge [k, v] pairs back into a parent object
            functional_1.intoObj);
        }
        default:
            return state;
    }
};
exports.default = formReducer;
//# sourceMappingURL=form.js.map